import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Spinner
} from 'reactstrap';
import { deleteOfferType } from 'service/offertype.service';
import { updateOfferType } from 'service/offertype.service';
import { addOfferType } from 'service/offertype.service';
import { getOfferTypes } from 'service/offertype.service';


const OfferType = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [offerTypeData, setOfferTypeData] = useState([]);
  const [newOfferType, setNewOfferType] = useState({
    name: '',
   description: '',
    id: 0,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  useEffect(() => {
    fetchOfferTypes();
  }, []);

  const toggleModal = () => {
    setIsUpdate(false);
    setIsSubmitting(false);
    setNewOfferType({ name: '', description: ''});
    setModalOpen(!modalOpen);
  };

  const toggleUpdateModal = (offertype) => {
    setNewOfferType(offertype);
    setIsSubmitting(false);
    setIsUpdate(true);
    setModalOpen(!modalOpen);
  };

  const fetchOfferTypes = async () => {
    try {
      const offertype = await getOfferTypes();
      console.log(offertype);
      setOfferTypeData(offertype.data.offerTypeFeed);
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOfferType((prevData) => ({ ...prevData, [name]: value }));

    

    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  
  };

//   const generateShortName = (text) => {
//     const words = text.trim().split(' ');
//     let initials = '';

//     if (words.length === 1) {
//       const word = words[0].toUpperCase();
//       if (word.length >= 2) {
//         initials = word.substring(0, 2);
//       } else {
//         initials = word.padEnd(2, '_');
//       }
//     } else {
//       words.forEach((word) => {
//         initials += word.charAt(0).toUpperCase();
//       });
//     }
//     setNewOfferType((prevData) => ({ ...prevData, shortName: initials }));
//   };

  const handleFormSubmit =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newOfferType.name.trim() === '') {
      errors.name = 'Name is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      try {
        const addedAdvertiser = await addOfferType(newOfferType);
        setIsSubmitting(false);
        setOfferTypeData((prevData) => [...prevData, newOfferType]);
        setNewOfferType({ name: '', description: '' });
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleFormUpdate =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newOfferType.name.trim() === '') {
      errors.name = 'Name is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      // console.log(newOfferType);
      try {
        const addedAdvertiser = await updateOfferType(newOfferType.id, newOfferType);
        setIsSubmitting(false);
        fetchOfferTypes()
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleDeleteOfferType = async (id) => {
    try {
      await deleteOfferType(id);
      setOfferTypeData((prevData) => prevData.filter((advertiser) => advertiser.id !== id));
    } catch (error) {
      console.error('Error deleting advertiser:', error);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <Card>
          <CardHeader className="d-flex justify-content-between">
            <h5>Offer Type</h5>
            <Button color="secondary" onClick={toggleModal}>
              <i className="ni ni-fat-add" /> Add Offer Type
            </Button>
          </CardHeader>

          <div className="p-4">
          <Table responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {offerTypeData.map((offertype, index) => (
                  <tr key={index}>
                    <td>
                    
                  <span>{offertype.name}</span>
                 
                    </td>
                    <td>{offertype.description}</td>
                  
                    <td class="text-sm">
                      <Button color='success' className=" btn btn-sm mx-3 text-white" onClick={()=>toggleUpdateModal(offertype)} >
                      <i class="fas fa-user-edit " aria-hidden="true"></i>
                      </Button>
                      <Button color='danger' className='btn btn-sm text-white'  onClick={() => handleDeleteOfferType(offertype.id)}>
                      <i class="fas fa-trash" aria-hidden="true"></i>
                      </Button>
                      </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>

        <Modal isOpen={modalOpen} toggle={toggleModal} size="md">
          <ModalHeader toggle={toggleModal}>Add Offer Type</ModalHeader>
          <ModalBody>
            <form onSubmit={handleFormSubmit}>
              <FormGroup>
                <Label for="name">Name</Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  value={newOfferType.name}
                  onChange={handleInputChange}
                  invalid={!!formErrors.name}
                />
                {formErrors.name && <FormFeedback>{formErrors.name}</FormFeedback>}
              </FormGroup>
              <FormGroup>
                <Label for="email">Description</Label>
                <Input
                  type="text"
                  name="description"
                  value={newOfferType.description}
                  onChange={handleInputChange}
                />
              </FormGroup>
              
            </form>
          </ModalBody>
          <ModalFooter>
            { !isUpdate?
            <Button color="primary" onClick={handleFormSubmit} disabled={isSubmitting} >
            {isSubmitting ? <Spinner size="sm" color="light" /> : 'Submit'}
            </Button>
            :  <Button color="primary" onClick={handleFormUpdate} disabled={isSubmitting} >
            {isSubmitting ? <Spinner size="sm" color="light" /> : 'Update'}
            </Button>
            }
            <Button color="secondary" onClick={toggleModal}>
              Close
            </Button>
          
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default OfferType;
